'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringValidator = exports.StringRule = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _validator = require('validator');

var _validator2 = _interopRequireDefault(_validator);

var _Any = require('./Any');

var _helpers = require('../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/****************************************
  Rule Builder
*****************************************/

var StringRule = function (_AnyRule) {
  _inherits(StringRule, _AnyRule);

  function StringRule(rules, message) {
    _classCallCheck(this, StringRule);

    // If this object is being made for the first time (and not chained as `setRule` does below)
    var _this = _possibleConstructorReturn(this, (StringRule.__proto__ || Object.getPrototypeOf(StringRule)).call(this, rules));

    if (!_this.getRule('type')) {
      _this.rules.type = message ? { rule: 'string', message: message } : 'string';
    }
    return _this;
  }

  _createClass(StringRule, [{
    key: 'setRule',
    value: function setRule(ruleName, rule) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof ruleName !== 'string') throw new Error('`ruleName` argument should be a string');
      return new StringRule(Object.assign({}, this.toJSON(), _defineProperty({}, ruleName, !Object.keys(options).length ? rule : Object.assign({}, options, { rule: rule }))));
    }
  }, {
    key: 'length',
    value: function length(_length, message) {
      return this.setRule('length', _length, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'maxLength',
    value: function maxLength(_maxLength, message) {
      return this.setRule('maxLength', _maxLength, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'minLength',
    value: function minLength(_minLength, message) {
      return this.setRule('minLength', _minLength, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'regex',
    value: function regex(expression, message) {
      if (typeof expression === 'string') throw new Error('Expressions should be Expression Literals, not Strings');
      if (!(expression instanceof RegExp)) throw new Error('This is not a regular expression');
      return this.setRule('regex', expression, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'email',
    value: function email(message) {
      return this.setRule('email', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'ascii',
    value: function ascii(message) {

      return this.setRule('ascii', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'alpha',
    value: function alpha() {
      var strict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var message = arguments[1];

      return this.setRule('alpha', true, (0, _helpers.cleanObject)({ strict: !!strict, message: message }));
    }
  }, {
    key: 'alphaNum',
    value: function alphaNum() {
      var strict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var message = arguments[1];

      return this.setRule('alphaNum', true, (0, _helpers.cleanObject)({ strict: !!strict, message: message }));
    }
  }, {
    key: 'lowercase',
    value: function lowercase(message) {
      return this.setRule('lowercase', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }, {
    key: 'uppercase',
    value: function uppercase(message) {
      return this.setRule('uppercase', true, (0, _helpers.cleanObject)({ message: message }));
    }
  }]);

  return StringRule;
}(_Any.AnyRule);

/****************************************
  Validator
*****************************************/

var StringValidator = function (_AnyValidator) {
  _inherits(StringValidator, _AnyValidator);

  function StringValidator() {
    _classCallCheck(this, StringValidator);

    return _possibleConstructorReturn(this, (StringValidator.__proto__ || Object.getPrototypeOf(StringValidator)).apply(this, arguments));
  }

  _createClass(StringValidator, [{
    key: 'type',
    value: function type(value) {
      return typeof value === 'string' ? '' : 'Invalid string';
    }
  }, {
    key: 'length',
    value: function length(value, _length2) {
      return value.length === _length2 ? '' : 'Must be ' + _length2 + ' characters';
    }
  }, {
    key: 'maxLength',
    value: function maxLength(value, _maxLength2) {
      return value.length <= _maxLength2 ? '' : 'Cannot exceed ' + _maxLength2 + ' characters';
    }
  }, {
    key: 'minLength',
    value: function minLength(value, _minLength2) {
      return value.length >= _minLength2 ? '' : 'Must be at least ' + _minLength2 + ' characters';
    }
  }, {
    key: 'regex',
    value: function regex(value, expression) {
      return expression.test(value) ? '' : 'Is not valid';
    }
  }, {
    key: 'email',
    value: function email(value) {
      return _validator2.default.isEmail(value) ? '' : 'Is not a valid email';
    }
  }, {
    key: 'ascii',
    value: function ascii(value) {
      return _validator2.default.isAscii(value) ? '' : 'Must only contain ASCII characters';
    }
  }, {
    key: 'alpha',
    value: function alpha(value, rule) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (options.strict) {
        return _validator2.default.isAlpha(value) ? '' : 'Must only contain alphabetic characters';
      } else {
        return _validator2.default.isAlpha(value.replace(/[\s]+/g, '')) ? '' : 'Must only contain alphabetic and whitespace characters';
      }
    }
  }, {
    key: 'alphaNum',
    value: function alphaNum(value, rule) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (options.strict) {
        return _validator2.default.isAlphanumeric(value) ? '' : 'Must only contain alphabetic or numeric characters';
      } else {
        return _validator2.default.isAlphanumeric(value.replace(/[\s]+/g, '')) ? '' : 'Must only contain alphabetic, numeric, and whitespace characters';
      }
    }
  }, {
    key: 'lowercase',
    value: function lowercase(value) {
      return _validator2.default.isLowercase(value) ? '' : 'Must be lowercase';
    }
  }, {
    key: 'uppercase',
    value: function uppercase(value) {
      return _validator2.default.isUppercase(value) ? '' : 'Must be uppercase';
    }
  }]);

  return StringValidator;
}(_Any.AnyValidator);

exports.StringRule = StringRule;
exports.StringValidator = StringValidator;